export const AccessGroupUrl = {
  ACCESS_GROUP: '/access-groups{/id}',
  SEARCH:
    '/access-groups{?page,size,sort*,name,roleId*,selectedIds*,description}',
} as const;
